{
    "FileUpload_DragAndDrop": "Datei hier ablegen oder klicken, um Datei auszuwählen",
    "FileUpload_DropFileHere": "Datei hier ablegen",
    "FileUpload_Accepted": "Datei wird akzeptiert",
    "FileUpload_Rejected": "Datei wird abgelehnt",
    "FileUpload_SelectedFile": "Ausgewählte Datei: {}",
    "FileUpload_Validation_OverMaxSize": "Die Dateigröße überschreitet die maximal zulässige Größe von {}",
    "FileUpload_Validation_MaxDimensions": "Die Dateiabmessungen überschreiten die maximal zulässigen Abmessungen von {}x{}",
    "FileUpload_Validation_MinDimensions": "Die Dateiabmessungen liegen unter den zulässigen Mindestabmessungen von {}x{}",
    "FileUpload_Validation_NotTransparent": "Der Dateihintergrund ist nicht transparent",
    "NAME": "FileUploadLanguage"
}